import { useNavigate } from "react-router-dom";

export default function Card({ title, text, image, route }) {
  const navigate = useNavigate();

  return (
    <div className="card" onClick={() => navigate(route)}>
      <img src={image} alt={title} className="card-img" />
      <h2>{title}</h2>
      <div className="card-hover-text">
        <p>{text}</p>
      </div>
    </div>
  );
}